import React, { useContext } from 'react';
import { StoresContext, StoreState } from '../../../App';

interface Search {
    name?: string,
    type?: string,
    features: SearchItem[],
}

interface SearchItem {
    id: string,
    name: string,
    value: string,
}

const federalNetworkCompanies: Search[] = [
    {
        name: 'ДИСТРИБЬЮТОРЫ',
        type: 'search',
        features: [
            { id: 'etm', name: 'Офисы продаж компании «ЭТМ»', value: 'этм' },
            { id: 'rus-svet', name: 'Офисы продаж компании «Русский свет»', value: 'русский свет' },
        ]
    }
];

const BlockSearch = ({
    features,
    search,
    setSearch,
}: {
    features: SearchItem[];
    search: StoreState['search'];
    setSearch: StoreState['setSearch'];
}) => {
    const selected: string = search;
    const toggleFeature = (value: string) => {
        setSearch(value);
    };
    return (
        <div className="filter-categories">
            {features.map(({ id, name, value }) => (
                <div
                    key={id}
                    className={'filter-categories-item' + (selected === value ? ' filter-categories-item--active' : '')}
                    onClick={() => toggleFeature(selected === value ? '' : value)}
                >
                    <div className="filter-categories-item__name">
                        {name}
                    </div>
                    <button className="filter-categories-item__btn">
                        {selected === value ? 'Сбросить' : 'Показать'}
                    </button>
                </div>
            ))}
        </div>
    );
};

export default function FeatureFilters() {
    const { search, setSearch } = useContext(StoresContext);
    
    return (
        <div className="feature-filter">
            <div className="feature-filter__item feature-filter-item">
                <div className="feature-filter-item__title">{federalNetworkCompanies[0].name}</div>
                <div className="feature-filter-item__body">
                    <BlockSearch
                        features={federalNetworkCompanies[0].features}
                        search={search}
                        setSearch={setSearch}
                    />
                </div>
            </div>
        </div>
    );
}